<template>
  <div :class="['input', { 'is-disabled': disabled }, { 'is-error': isError }]">
    <label class="input__label" :for="id"><slot></slot></label>
    <div class="input__helptext" v-if="inputHelperSlot">
      <slot name="input-helptext"></slot>
    </div>
    <input
      class="input__input"
      :type="type"
      :id="id"
      :name="id"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxlength="isMaxLength"
      v-on:input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'CustomInput',
  props: {
    type: {
      type: String,
      default: 'text',
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
    },
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    img: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
    },
    isMaxLength: {
      type: Number,
      default: 50,
    },
  },
  computed: {
    inputHelperSlot() {
      return this.$slots['input-helptext']
    },
  },
}
</script>

<style lang="scss" scoped>
$input-component-width: 100%;
$forestGreen: #022d2d;
$forestGreen200: #247373;
$white: #ffffff;
$grey: #545a5a;
$grey100: #9ca5a5;
$grey300: #e7edeb;
$danger: #e0182d;

//** Input base
.input {
  position: relative;
  margin: 0 0 4px;
  max-width: $input-component-width;
  width: 100%;
  text-align: left;
  //** Input label
  &__label {
    font-weight: bold;
    font-size: 1em;
    line-height: 0;
    max-width: fit-content;
    padding-bottom: 12px;
    display: inline-block;
  }
  //** Input itself
  &__input {
    display: block;
    box-sizing: border-box;
    height: 42px;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    background-color: $white;
    border: 1px solid $grey300;
    border-radius: 7px;
    margin: 0;
    &::placeholder {
      color: $grey100;
    }
    // Placeholder truncation
    [placeholder] {
      text-overflow: ellipsis;
    }
    // Active state:: Input label
    &:focus {
      outline: none;
      border: 1px solid $forestGreen200;
    }
    // removes box-shadow on Firefox if input required
    &:required {
      box-shadow: none;
    }
  }
  //** Helper text
  &__helptext {
    font-size: 12px;
    color: $grey;
  }
  //** Error message container
  &__error-message {
    order: -2;
    min-height: 22px;
    color: $danger;
    font-size: 12px;
    padding-top: 3px;
    text-align: left;
  }
  //** Input currency prop
  &.has-currency {
    position: relative;
    .input__input {
      padding-left: 32px;
    }
    &:before {
      content: 'R';
      position: relative;
      font-size: 14px;
      color: $grey300;
      left: 16px;
      bottom: 30px;
      height: 0;
    }
  }
  //** Input has icon img
  &__icon {
    position: absolute;
    right: 20px;
    top: 55%;
    color: $grey;
    &:hover {
      cursor: pointer;
    }
    img {
      border: 1px solid rgba(#000, 0.16);
      padding: 6px 4px 6px 2px;
      background-color: $white;
      border-radius: 3px;
    }
  }
  // disabled
  &.is-disabled {
    opacity: 0.5;
    box-shadow: none;
    cursor: initial;
    user-select: none;
    pointer-events: none;
    // prevent user-select effect if input has value
    .input__input {
      &::selection {
        background: transparent;
      }
      &::-moz-selection {
        background: transparent;
      }
    }
  }
}

// show-hide-input
.control {
  &__password {
    display: flex;
    flex-direction: row;
    position: relative;
  }
  &__password--input {
    width: 85%;
    border-right: none;
    border-radius: 7px 0 0 7px;
  }
  #password_in {
    -webkit-appearance: none;
    border-radius: 7px 0 0 7px;
    border-right: none;
  }
  &__password--icon {
    height: 42px;
    position: absolute;
    bottom: 4px;
    background-color: $white;
    right: 1px;
    width: 15%;
    border: 1px solid $grey300;
    border-left: none;
    border-radius: 0 7px 7px 0;
    color: $forestGreen200;
    span {
      position: absolute;
      top: 8px;
      left: 16px;
    }
  }
  .control__password--input:focus-within + .control__password--icon {
    border: 1px solid $forestGreen200;
    border-left: none;
  }
}
</style>
